<template>
  <div class="partywork flex-row justify-between">
    <div class="text-wrapper_8 flex-col">
      <span class="text_23">党支部简介</span>
    </div>
    <!--轮播图-->
    <el-carousel :interval="3000" arrow="never" class="block_20 flex-col">
      <el-carousel-item :key="index" class="image-wrapper_1"  v-for="(item, index) in picturesList">
        <img :src="item.fileUrl" style="width: 100%;height: 100%;">
      </el-carousel-item>
    </el-carousel>

    <div class="text-wrapper_1 flex-col">
      <div class="paragraph" v-html="content"></div>
    </div>
    <img class="block_21" referrerpolicy="no-referrer" :src="require('@/assets/aboutSailHero/img/fl.jpg')"/>
    <div class="block_19 flex-col" >
      <div class="box_17 flex-row justify-between">
        <div class="section_1 flex-col"></div>
        <div class="image-text_2 flex-row justify-between">
          <span class="text-group_1">党建动态</span>
          <div class="box_4 flex-col"></div>
        </div>
      </div>
      <div v-for="(item, index) in dynamicsList">
        <div class="box_5 flex-col justify-end alltime" @click="openUrl(item, '党建动态', index)">
          <div class="text-wrapper_22 flex-row justify-between">
            <span class="text_12" >{{item.about_name}}</span>
            <span class="text_13" >查看详情</span>
          </div>
          <div class="section_2 flex-col"></div>
          <s></s>
        </div>
      </div>

    </div>
    <div class="block_5 flex-row">
      <Pagination v-show="total>0" :total="total" :background="false" :page.sync="params.pageIndex" :limit.sync="params.pageSize"
                  @pagination="getData"/>
    </div>

  </div>

</template>
<script>
import Pagination from "./Pagination";
export default {
  components: { Pagination },
  name: "PartyBuildingWork",
  data() {
    return {
      params:{
        pageIndex:1,
        pageSize:5,
      },
      total:8,
      content:"<p>党务工作是党建过程中的具体呈现，党建则是党务工作的内容，党建工作在内容上更加丰富，包括政治建设、思想建设、组织建设、作风建设、纪律建设、制度建设等，党务工作则更加具体，是实现党建工作的载体、形式、方法和路径。</p><p>基层治理是国家治理的基石。近些年，各地党建引领基层治理的效果显现。但是，仍有基层党组织在工作中陷入将党建等同于党务的认识误区，把二者混淆。</p><p>党务工作是党建过程中的具体呈现，党建则是党务工作的内容，党建工作在内容上更加丰富，包括政治建设、思想建设、组织建设、作风建设、纪律建设、制度建设等，党务工作则更加具体，是实现党建工作的载体、形式、方法和路径。</p>",
      dynamicsList:[{"about_name":"入选“全国企业党建优秀课题成果”"},{"about_name":"入选“全国企业党建优秀课题成果”"},{"about_name":"入选“全国企业党建优秀课题成果”"},{"about_name":"入选“全国企业党建优秀课题成果”"},{"about_name":"入选“全国企业党建优秀课题成果”"},],
      picturesList:[{"filePath":"http://49.4.78.30:9930/Snapshot\\0\\cbe8e1ed-c8de-4680-900e-cad16a31ee3f\\优秀民营企业.jpg"},
        {"filePath":"http://49.4.78.30:9930/Snapshot\\0\\8343a6af-cf71-43c0-a413-66ed4efc8042\\河北省产业创新中心.jpg"},
        {"filePath":"http://49.4.78.30:9930/Snapshot\\0\\b787d1ed-4ab7-4053-bbd6-7b43b9640c0c\\质量管理体系认证.jpg"},]
    }
  },
  methods:{
    openUrl(item, type, index){
      let that = this;
      let list = that.dynamicsList;
      let listStr = JSON.stringify(list);
      const { href } = that.$router.resolve({
        path: "/Client/CorporateCultureDetails", query: {
          id: item.id,
          bigTitle: "党建工作",
          modelitem: type,
          about_content: item.about_content,
          about_name: item.about_name,
          update_time: item.update_time,
          list: listStr,
          index: index
        }
      });
      window.open(href, "_blank");
    },
    //获取党建动态列表
    getData() {
      var _this = this;
      _this.$api.post(
          "/Client/getPartyBuildingDynamics",
          {pageSize:_this.params.pageSize,pageIndex:_this.params.pageIndex},
          function (res) {
            if (res.code == "200") {
              _this.total = res.count;
              _this.dynamicsList = res.data;
            }
          }
      );
    },
    //获取党建轮播图列表
    getData1() {
      var _this = this;
      _this.$api.post(
          "/Client/getCarouselPictures",
          {},
          function (res) {
            if (res.code == "200") {
              _this.total = res.count;
              _this.picturesList = res.data;
            }
          }
      );
    },
    //获取党总支介绍
    getData2() {
      var _this = this;
      _this.$api.post(
          "/Client/getIntroduction",
          {},
          function (res) {
            if (res.code == "200") {
              _this.total = res.count;
              _this.content = res.data.about_content;
            }
          }
      );
    },
  },
  mounted() {
    let that = this;
    that.getData();
    that.getData1();
    that.getData2();
  },
}
</script>

<style scoped>
.partywork {
  width: 1120px;
  height: 1513px;
  position: relative;

.alltime,.alltime *{-webkit-transition: all .4s cubic-bezier(.4,0,.2,1); -moz-transition: all .4s cubic-bezier(.4,0,.2,1); transition: all .4s cubic-bezier(.4,0,.2,1);}

.alltime s{display: block;width: 0%;height: 3px;background: rgba(218, 28, 19, 1);position: absolute;left: 0;bottom: 0;}

.alltime:hover s{width: 100%;}

.block_5 {
  height: 22px;
  position: absolute;
  right: 0;
  bottom: -130px;
}

.block_19 {
  width: 1127px;
  height: 494px;
  background: linear-gradient(180deg, #FFFFFF 0%, #FFF2EB 100%);
  position: absolute;
  top: 1100px;
  left: 10px;

}

.box_17 {
  width: 178px;
  height: 48px;
  margin: 40px 0 0 474px;
}

.section_1 {
  width: 28px;
  height: 48px;
  background: url('../../../../assets/aboutSailHero/img/z_1.png') 0px 0px no-repeat;
  background-size: 29px 48px;
}

.image-text_2 {
  width: 141px;
  height: 48px;
}

.text-group_1 {
  width: 104px;
  height: 26px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 26px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  line-height: 26px;
  margin-top: 11px;
}

.box_4 {
  width: 28px;
  height: 48px;
  background: url('../../../../assets/aboutSailHero/img/y_1.png') 0px 0px no-repeat;
  background-size: 29px 48px;
}

.box_5 {
  width: 1079px;
  height: 74px;
  margin-left: 20px;
  position: relative;
  cursor: pointer;
}

.box_5:hover {
  width: 1079px;
  height: 74px;
  margin-left: 20px;


.text_12 {
  width: 304px;
  height: 22px;
  overflow-wrap: break-word;
  color: rgba(218, 28, 19, 1);
  font-size: 20px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 22px;
  cursor: pointer;
}

}
.text-wrapper_22 {
  width: 1050px;
  height: 22px;
  margin: 24px 0 0 15px;
}

.text_12 {
  width: 304px;
  height: 22px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 20px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 22px;
  cursor: pointer;
}

.text_13 {
  width: 56px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(118, 118, 118, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin-top: 4px;
  cursor: pointer;
}

.section_2 {
  background-color: rgba(190, 190, 190, 0.5);
  width: 1079px;
  height: 1px;
  margin-top: 20px;
}

.block_21 {
  width: 1126px;
  height: 610px;
  position: absolute;
  top: 500px;
  left: 10px;
}

.block_20 {
  height: 330px;
  width: 441px;
  position: absolute;
  left: 10px;
  top: 140px;
  z-index: 1;
}

.image-wrapper_1 {
  height: 330px;
  width: 441px;
}

.text-wrapper_8 {
  height: 52px;
  background: url('../../../../assets/aboutSailHero/img/ds.jpg') 100% no-repeat;
  background-size: 100% 100%;
  width: 427px;
  position: absolute;
  left: 467px;
  top: 93px;
  z-index: 1;
}

.text_23 {
  width: 110px;
  height: 22px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 22px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  line-height: 22px;
  margin: 15px 0 0 18px;
}

.text-wrapper_1 {
  background-color: rgba(249, 238, 230, 1);
  border-radius: 12px;
  width: 716px;
  height: 366px;
  position: absolute;
  top: 122px;
  left: 421px;
}

.paragraph {
  margin-top: 55px;
  margin-left: 48px;
}

}
</style>
